var ve = Object.defineProperty;
var he = (e, n, t) => n in e ? ve(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var j = (e, n, t) => he(e, typeof n != "symbol" ? n + "" : n, t);
import { l as K, t as _ } from "./log-C99uV6ya.js";
import { h as Sn, c as Tn, d as In, f as Cn, e as Dn, g as Rn, p as Mn, a as kn, b as On } from "./log-C99uV6ya.js";
import { UAParser as we } from "ua-parser-js";
import { useRef as y, useCallback as b, useEffect as E, useState as C, useDeferredValue as Ee } from "react";
import * as pe from "ramda";
import { clone as be } from "ramda";
const ye = 32, ge = {
  Enter: "onEnter",
  Backspace: "onBackspace",
  Delete: "onDelete",
  Esc: "onEsc",
  Escape: "onEsc",
  ArrowUp: "onUp",
  ArrowDown: "onDown",
  ArrowLeft: "onLeft",
  ArrowRight: "onRight",
  Tab: "onTab"
}, x = {
  onEnter: [],
  onDelete: [],
  onBackspace: [],
  onEsc: [],
  onUp: [],
  onDown: [],
  onLeft: [],
  onRight: [],
  onTab: [],
  onSpaceBar: []
};
function Ye(e) {
  return oe() || document.addEventListener("keydown", ce, !0), Object.keys(e).forEach((n) => {
    const t = e[n];
    if (!t)
      return;
    const r = x[n];
    r && r.push(t);
  }), () => {
    Le(e);
  };
}
function oe() {
  return Object.values(x).some(
    (e) => !!e.length
  );
}
function ce(e) {
  let n = ge[e.key];
  if (e.keyCode === ye && (n = "onSpaceBar"), !n)
    return;
  const { length: t } = x[n];
  if (n === "onSpaceBar" && t && e.preventDefault(), !!t)
    for (let r = t - 1; r >= 0; r--) {
      const o = x[n][r];
      if (o(e) !== !1) {
        e.stopPropagation();
        break;
      }
    }
}
function Le(e) {
  Object.keys(e).forEach((n) => {
    const t = e[n], r = x[n];
    if (r) {
      const o = r.findIndex((s) => s === t);
      o !== -1 && r.splice(o, 1);
    }
  }), oe() || document.removeEventListener("keydown", ce, !1);
}
const $e = (e) => [e == null ? void 0 : e.firstname, e == null ? void 0 : e.lastname].filter(Boolean).join(" "), Fe = (
  // eslint-disable-next-line
  navigator.userAgent || navigator.vendor || window.opera
), se = new we(Fe), { name: Q } = se.getOS(), { type: X } = se.getDevice(), ie = Q === "iOS" || window.orientation !== void 0 && Q === "Mac OS", Je = window.matchMedia("(pointer: coarse)").matches, ue = ie || X === "mobile" || X === "tablet", p = document.createElement("textArea");
p.setAttribute("readonly", "");
p.tabIndex = -1;
p.style.position = "absolute!important";
p.style.width = "0";
p.style.height = "0";
p.style.overflow = "hidden";
p.style.clip = "rect(0, 0, 0, 0)";
p.style.zIndex = "-1";
const Se = (e, n) => {
  const t = (s) => {
    p.value = s, n.body.appendChild(p);
  }, r = () => {
    if (ie) {
      const s = n.createRange();
      s.selectNodeContents(p);
      const c = e.getSelection();
      c == null || c.removeAllRanges(), c == null || c.addRange(s);
    } else
      p.select();
    p.setSelectionRange(0, 999999);
  }, o = () => {
    var s;
    if ((s = navigator.clipboard) != null && s.writeText && e.isSecureContext)
      return navigator.clipboard.writeText(p.value);
    {
      const c = n.execCommand("copy");
      if (n.body.removeChild(p), !c)
        throw new Error("copy command was unsuccessful");
    }
  };
  return async (s) => {
    t(s), r(), o();
  };
}, Ge = Se(window, document), Te = () => {
  const e = document.createElement("a");
  return document.body.appendChild(e), e.style.display = "none", (n, t) => {
    e.href = n, e.target = "_blank", e.download = t || "untitled", e.click();
  };
}, Ze = Te();
function Qe(e) {
  e.getTracks().forEach((n) => n.stop());
}
function Xe(e, n = () => 0) {
  let t = 1;
  return (...r) => new Promise((o) => {
    const s = () => {
      e(...r).then(o).catch(() => setTimeout(s, n(t++)));
    };
    s();
  });
}
class $ {
  constructor() {
    j(this, "_eventHandlers", /* @__PURE__ */ new Set());
    j(this, "_invocationCounter", 0);
  }
  add(n) {
    return this._eventHandlers.add(n), () => {
      this._eventHandlers.delete(n);
    };
  }
  remove(n) {
    this._eventHandlers.delete(n);
  }
  invoke(n) {
    this._invocationCounter += 1, this._eventHandlers.forEach((t) => t(n));
  }
  hasListener() {
    return this._eventHandlers.size > 0;
  }
  hasBeenInvoked() {
    return this._invocationCounter > 0;
  }
}
const Ne = (e = 0) => new Promise((n) => {
  setTimeout(() => n(null), e);
}), J = 1e3, Ie = 60 * J, Ce = 60 * Ie, en = 24 * Ce;
function nn(e) {
  if (!e) return "";
  const n = Math.round(e / 1e3), t = Math.floor(n / 3600), r = Math.floor(n % 3600 / 60), o = Math.floor(n % 60);
  return [t, r, o].filter((s, c) => c === 0 ? !!s : !0).map(
    (s) => s.toLocaleString(window.appConfig.language, {
      minimumIntegerDigits: 2,
      useGrouping: !1
    })
  ).join(" : ");
}
function H(e, n, t) {
  const {
    shouldRunFirst: r = !1,
    shouldRunLast: o = !0,
    onAfterLastRun: s,
    onAfterFirstRun: c
  } = t || {};
  let l;
  const d = (...f) => {
    const w = !l;
    l ? (window.clearTimeout(l), l = void 0) : r && (e(...f), c == null || c(...f)), l = window.setTimeout(async () => {
      if (o && !(w && r))
        try {
          await e(...f);
        } finally {
          s == null || s(...f);
        }
      l = void 0;
    }, n);
  };
  return d.cancel = () => {
    clearTimeout(l);
  }, d;
}
function le(e, n, t) {
  const {
    shouldRunFirst: r,
    shouldRunLast: o,
    key: s,
    onAfterFirstRun: c,
    onAfterLastRun: l
  } = t || {};
  if (!s)
    return H(e, n, {
      shouldRunFirst: r,
      shouldRunLast: o,
      onAfterFirstRun: c,
      onAfterLastRun: l
    });
  const d = /* @__PURE__ */ new Map();
  function f(m) {
    const i = d.get(m);
    if (i) return i;
    const a = H(e, n, {
      shouldRunFirst: r,
      shouldRunLast: o,
      onAfterLastRun: (...u) => {
        d.delete(m), l == null || l(...u);
      },
      onAfterFirstRun: (...u) => {
        c == null || c(...u);
      }
    });
    return d.set(m, a), a;
  }
  const w = (...m) => {
    const i = s(...m);
    f(i)(...m);
  };
  return w.cancel = (m) => {
    if (m) {
      const i = d.get(m);
      i && i.cancel();
    } else
      d.forEach((i) => {
        i.cancel();
      });
  }, w;
}
function tn(e, n, t) {
  return le(e, n, t);
}
function rn(e, n, t) {
  const {
    key: r,
    onlyResolveLast: o = !0,
    cancelErrorMessage: s = "canceled"
  } = t || {};
  let c = [];
  const l = /* @__PURE__ */ new Map(), d = (i) => {
    if (!r) return c;
    if (!i) return pe.flatten(Object.values(Object.fromEntries(l)));
    const a = l.get(i);
    if (a) return a;
    const u = [];
    return l.set(i, u), u;
  }, f = (i) => {
    i ? l.delete(i) : (c = [], l.clear());
  }, w = le(
    async (...i) => {
      const a = r == null ? void 0 : r(...i), u = d(a);
      return e(...i).then((v) => (o ? u[u.length - 1].resolve(v) : u.forEach(({ resolve: S }) => S(v)), v)).catch((v) => {
        o ? u[u.length - 1].reject(v) : u.forEach(({ reject: S }) => {
          S(v);
        });
      });
    },
    n,
    {
      onAfterLastRun(...i) {
        const a = r == null ? void 0 : r(...i);
        f(a);
      },
      shouldRunFirst: t == null ? void 0 : t.shouldRunFirst,
      shouldRunLast: t == null ? void 0 : t.shouldRunLast,
      key: r ? (...i) => r(...i) : void 0
    }
  ), m = (...i) => new Promise((a, u) => {
    const v = r == null ? void 0 : r(...i);
    d(v).push({ resolve: a, reject: u }), w(...i);
  });
  return m.runImmediately = (...i) => new Promise((a, u) => {
    const v = r == null ? void 0 : r(...i), S = d(v);
    e(...i).then((R) => {
      a(R), o || S.forEach(({ resolve: M }) => M(R));
    }).catch((R) => {
      u(R), o || S.forEach(({ reject: M }) => M(R));
    }).finally(() => {
      f(v);
    }), w.cancel(v);
  }), m.cancel = (i) => {
    w.cancel(i);
    const a = d(i), u = new Error(s);
    o ? a[a.length - 1].reject(u) : a.forEach(({ reject: v }) => {
      v(u);
    }), f(i);
  }, m;
}
function on(e, n) {
  let t = [];
  const r = H(async () => {
    const o = t;
    t = t.slice(o.length), await e(o);
  }, n);
  return (o) => {
    t.push(o), r();
  };
}
function cn(e, n) {
  let t = [], r = [];
  const o = () => {
    r.forEach((c, l) => {
      c(null), l === r.length - 1 && (r = []);
    });
  }, s = H(async () => {
    const c = t;
    t = t.slice(c.length), await e(c), o();
  }, n);
  return (c) => new Promise((l) => {
    t.push(c), r.push(l), s();
  });
}
function sn(e, n, t = !0) {
  let r, o, s;
  return (...c) => {
    o = !0, s = c, r || (t && (o = !1, e(...s)), r = window.setInterval(() => {
      if (!o) {
        window.clearInterval(r), r = void 0;
        return;
      }
      o = !1, e(...s);
    }, n));
  };
}
function un() {
}
function W(e) {
  const n = y(e);
  return n.current = e, n;
}
function N(e) {
  const n = W(e);
  return b(
    (...t) => {
      var r;
      return (r = n.current) == null ? void 0 : r.call(n, ...t);
    },
    // No need for ref dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
const V = new $(), Y = new $();
let P = document.hasFocus();
window.addEventListener("blur", () => {
  P && (P = !1, V.invoke());
});
window.addEventListener("focus", () => {
  P = !0, Y.invoke();
});
function ln(e, n, t = !1) {
  const r = N(e), o = N(n);
  E(() => {
    if (!t)
      return P || r(), V.add(r), Y.add(o), () => {
        Y.remove(o), V.remove(r);
      };
  }, [t, r, o]);
}
function an() {
  return !P;
}
function dn() {
  const [e, n] = C(window.navigator.onLine);
  return E(() => {
    function t() {
      n(window.navigator.onLine);
    }
    return window.addEventListener("online", t), window.addEventListener("offline", t), () => {
      window.removeEventListener("offline", t), window.removeEventListener("online", t);
    };
  }, []), e;
}
function fn(e, n, t = J, r = (o) => o) {
  const [o, s] = C(e - n());
  return E(() => {
    const c = e - n();
    if (c < 0) return;
    s(c);
    const l = setInterval(() => {
      const d = e - n();
      d > 0 ? s(d) : (clearInterval(l), s(0));
    }, t);
    return () => {
      clearInterval(l);
    };
  }, [e, t, n]), r(o);
}
function mn(e, n, t, r = J, o = (s) => s) {
  const s = y(n || e()), c = y(), [l, d] = C(e() - s.current);
  return E(() => {
    t && clearInterval(c.current);
  }, [t]), E(() => {
    if (!t)
      return d(e() - s.current), c.current = setInterval(() => {
        d(e() - s.current);
      }, r), () => {
        clearInterval(c.current);
      };
  }, [r, e, t]), o(l);
}
function De(e) {
  E(e, []);
}
const vn = (e, n) => {
  const t = y();
  return E(() => {
    const r = t.current;
    return t.current = n, e(r || []);
  }, n);
};
function Re() {
  const e = y(), n = b((r, o) => {
    e.current && clearTimeout(e.current), e.current = setTimeout(r, o);
  }, []), t = b(() => {
    e.current && (clearTimeout(e.current), e.current = void 0);
  }, []);
  return E(
    () => () => {
      e.current && clearTimeout(e.current);
    },
    []
  ), { create: n, clear: t };
}
const Me = 250;
function ke(e, n, t, r = !0, o = Me) {
  const s = y(!1), c = y(!1), { create: l, clear: d } = Re(), f = y(), w = b(
    (u) => {
      const v = "button" in u && u.button === 0 || "touches" in u && u.touches.length > 0;
      c.current || !v || ("touches" in u && u.touches.length && (f.current = be(u)), c.current = !0, l(() => {
        e(u), s.current = !0;
      }, o));
    },
    [e, l, o]
  ), m = b(() => {
    s.current || (d(), c.current = !1);
  }, [d]), i = b(() => {
    s.current && (n == null || n()), s.current = !1, c.current = !1, d();
  }, [n, d]), a = b(
    (u) => {
      try {
        !s.current && c.current && (c.current = !1, t && u.preventDefault(), t == null || t(f.current || u), f.current = void 0);
      } catch (v) {
        K(v);
      }
      i();
    },
    [t, i]
  );
  return r ? {
    onTouchStart: w,
    onTouchEnd: a,
    onTouchMove: m
  } : {
    onMouseDown: w,
    onMouseUp: a,
    onmousemove: m,
    onMouseLeave: i,
    onTouchStart: w,
    onTouchEnd: a,
    onTouchMove: m
  };
}
function Oe(e) {
  const n = y(), t = y();
  return t.current !== e && (n.current = t.current), t.current = e, n.current;
}
const xe = 0;
function hn(e = 0, n) {
  const [t, r] = C(e), o = y(null), s = () => {
    o.current === null && (o.current = setInterval(() => {
      r((f) => f + 1);
    }, 1e3));
  }, c = () => {
    o.current !== null && (clearInterval(o.current), o.current = null);
  }, l = (f = 0) => {
    c(), r(f);
  }, d = (f, w) => {
    const m = _(xe, w), i = Math.floor(f / 3600), a = Math.floor(f % 3600 / 60), u = f % 60;
    return {
      hours: i ? `${String(_(i, w)).padStart(2, m)}` : "",
      minutes: `${String(_(a, w).padStart(2, m))}`,
      seconds: `${String(_(u, w)).padStart(2, m)}`
    };
  };
  return E(() => () => c(), []), {
    time: t,
    formattedTime: d(t, n),
    start: s,
    stop: c,
    reset: l
  };
}
function wn() {
  const [e, n] = C(!1);
  return [
    e,
    b(() => {
      n((t) => !t);
    }, [])
  ];
}
function En(e, n) {
  var o;
  const t = Oe(n), r = y();
  (!t || n.some((s, c) => s !== t[c])) && ((o = r.current) == null || o.call(r), r.current = e(t || []) ?? void 0), De(() => () => {
    var s;
    (s = r.current) == null || s.call(r);
  });
}
const Pe = (() => {
  var e, n;
  return typeof ((n = (e = window.screen) == null ? void 0 : e.orientation) == null ? void 0 : n.lock) == "function" && ue;
})(), q = (() => {
  const e = document.createElement("div");
  return typeof e.requestFullscreen == "function" || typeof e.webkitRequestFullscreen == "function" || typeof e.webkitEnterFullscreen == "function" || typeof e.mozRequestFullScreen == "function";
})();
function ae(e) {
  const n = e.requestFullscreen ?? e.webkitRequestFullscreen ?? e.webkitEnterFullscreen ?? e.mozRequestFullScreen;
  return n == null ? void 0 : n.bind(e);
}
function O() {
  return document.fullscreenElement ?? document.webkitFullscreenElement ?? document.mozFullScreenElement ?? null;
}
function _e() {
  const e = document.exitFullscreen ?? document.webkitExitFullscreen ?? document.webkitCancelFullScreen ?? document.mozCancelFullScreen;
  return e == null ? void 0 : e.bind(document);
}
function Be() {
  return !!O();
}
function He() {
  var e;
  Be() && ((e = _e()) == null || e());
}
function pn(e) {
  var n;
  (n = ae(e)) == null || n();
}
function Ae() {
  var n, t;
  const e = (t = (n = window.screen) == null ? void 0 : n.orientation) == null ? void 0 : t.type;
  if (e) {
    if (e.includes("landscape")) return "landscape";
    if (e.includes("portrait")) return "portrait";
  }
}
let B;
function ee() {
  const e = Ae();
  B && B !== e && de(B);
}
var te, re;
(re = (te = window.screen) == null ? void 0 : te.orientation) != null && re.addEventListener ? window.screen.orientation.addEventListener(
  "change",
  ee
) : window.addEventListener("orientationchange", ee);
function de(e) {
  var n, t, r;
  (r = (t = (n = window.screen) == null ? void 0 : n.orientation) == null ? void 0 : t.lock) == null || r.call(t, e), B = e;
}
function Ue() {
  const e = y(!0);
  return E(
    () => () => {
      e.current = !1;
    },
    []
  ), e;
}
function bn(e, {
  toggleFullscreenApi: n,
  useNativeFullscreenApi: t = !0,
  preferredOrientation: r,
  id: o,
  disableAutomaticRotation: s
} = {}) {
  var G, Z;
  const [c, l] = C(!1), [d, f] = C(
    (Z = (G = window.screen) == null ? void 0 : G.orientation) == null ? void 0 : Z.type
  ), w = ze(), m = Ee(w), i = Ue();
  if (t && !e)
    throw new Error(
      "Unable to enter fullscreen. You should provide elRef when useNativeFullscreenApi is set to true"
    );
  const a = b(async () => {
    var g;
    const h = e == null ? void 0 : e.current;
    if (!t) {
      l(!0);
      return;
    }
    if (h)
      try {
        let L;
        const T = h.querySelector("video");
        if (!s && Pe && (T || r))
          if (r) L = r;
          else {
            const { videoWidth: k, videoHeight: F } = T || {};
            if (!k || !F) {
              D(void 0);
              return;
            }
            L = k / F >= 1 ? "landscape" : "portrait";
          }
        q ? (await ((g = ae(h)) == null ? void 0 : g({ navigationUI: "hide" })), L && de(L)) : (l(!0), n && n(!0));
      } catch (L) {
        K(L);
      }
  }, [
    t,
    n,
    e,
    r,
    s
  ]), u = b(() => {
    if (D(void 0), !t) {
      l(!1);
      return;
    }
    q ? He() : (n && n(!1), l(!1));
  }, [t, n]), v = W(a), S = W(u);
  E(() => {
    const h = e == null ? void 0 : e.current;
    if (!q || !t) return;
    const g = () => {
      const k = O(), F = O() === h, I = ne();
      if (l(F), !k) {
        D(void 0);
        return;
      }
      (F || I === o) && D(F ? o : void 0);
    }, L = () => {
      o && D(o), l(!0);
    }, T = () => {
      D(void 0), l(!1);
    };
    return document.addEventListener("fullscreenchange", g, !1), document.addEventListener(
      "webkitfullscreenchange",
      g,
      !1
    ), document.addEventListener(
      "mozfullscreenchange",
      g,
      !1
    ), h && (h.addEventListener("webkitbeginfullscreen", L, !1), h.addEventListener("webkitendfullscreen", T, !1)), () => {
      document.removeEventListener(
        "fullscreenchange",
        g,
        !1
      ), document.removeEventListener(
        "webkitfullscreenchange",
        g,
        !1
      ), document.removeEventListener(
        "mozfullscreenchange",
        g,
        !1
      ), h && (h.removeEventListener(
        "webkitbeginfullscreen",
        L,
        !1
      ), h.removeEventListener(
        "webkitendfullscreen",
        T,
        !1
      ));
    };
  }, [t, e, o]), E(() => {
    var g, L, T, k;
    if (!t) return;
    const h = () => {
      var F, I;
      return f((I = (F = window.screen) == null ? void 0 : F.orientation) == null ? void 0 : I.type);
    };
    return (L = (g = window.screen) == null ? void 0 : g.orientation) != null && L.addEventListener ? (k = (T = window.screen.orientation) == null ? void 0 : T.addEventListener) == null || k.call(
      T,
      "change",
      h
    ) : window.addEventListener(
      "orientationchange",
      h
    ), () => {
      var F, I, z;
      (z = (I = (F = window.screen) == null ? void 0 : F.orientation) == null ? void 0 : I.removeEventListener) == null || z.call(
        I,
        "change",
        h
      ), window.removeEventListener(
        "orientationchange",
        h
      );
    };
  }, [t]);
  const R = b(() => {
    c ? u() : a();
  }, [c, a, u]);
  E(() => () => {
    try {
      O() && u();
    } catch (h) {
      K(h);
    }
  }, [u]), E(() => {
    o && requestAnimationFrame(() => {
      if (!i.current) return;
      const h = ne();
      h === o && !c ? v.current() : !h && c && S.current();
    });
  }, [
    o,
    c,
    S,
    i,
    v,
    m
  ]);
  const M = b(() => {
    D(o);
  }, [o]), U = b(() => {
    D(void 0);
  }, []), me = b(() => {
    c ? U() : M();
  }, [U, M, c]);
  return {
    fullscreen: c,
    toggleFullscreen: R,
    enterFullscreen: a,
    exitFullscreen: u,
    enterFullscreenIndirectly: M,
    exitFullscreenIndirectly: U,
    orientation: d,
    toggleFullscreenIndirectly: me
  };
}
function yn() {
  const [e, n] = C(!1);
  return E(() => {
    const t = () => {
      n(!!O());
    };
    return document.addEventListener("fullscreenchange", t, !1), document.addEventListener("webkitfullscreenchange", t, !1), document.addEventListener("mozfullscreenchange", t, !1), () => {
      document.removeEventListener("fullscreenchange", t, !1), document.removeEventListener("webkitfullscreenchange", t, !1), document.removeEventListener("mozfullscreenchange", t, !1);
    };
  }, []), e;
}
let A;
const fe = new $();
function ze() {
  const [e, n] = C(A);
  return E(() => fe.add(n), []), e;
}
function D(e) {
  const n = e !== A;
  A = e, n && fe.invoke(e);
}
function ne() {
  return A;
}
function gn(e) {
  return {
    ...ke(e),
    onContextMenu: (t) => {
      t.preventDefault(), ue || e(t);
    }
  };
}
export {
  $ as Action,
  en as DAY_MS,
  Ce as HOUR_MS,
  ie as IS_IOS,
  Ie as MINUTE_MS,
  J as SECOND_MS,
  Fe as UA,
  rn as asyncDebounce,
  Ne as asyncDelay,
  Ye as captureKeyboardEvents,
  Sn as compareVersions,
  Ge as copyToClipboard,
  tn as debounce,
  on as debounceWithBuffer,
  cn as debounceWithBufferAsync,
  Tn as deleteFromArrayEnd,
  In as deleteFromArrayStart,
  Ze as downloadFile,
  Cn as findLast,
  Dn as findLastIndex,
  nn as formatTimeToHHMMSS,
  Rn as getJwtExpirationDate,
  $e as getUserDisplayName,
  an as isBackgroundModeActive,
  Be as isDocumentInFullscreenMode,
  q as isNativeFullscreenSupported,
  Pe as isOrientationLockSupported,
  ue as isPhoneOrTablet,
  Je as isTouchAvailable,
  de as lockOrientation,
  un as noop,
  Mn as parseJwt,
  Xe as retryPromiseUntilSucceed,
  pn as safeEnterFullscreen,
  He as safeExitFullscreen,
  Te as saveToDisk,
  D as setCurrentFullscreenComponentId,
  Qe as stopStream,
  sn as throttle,
  kn as to2DigitNumber,
  On as toEnglishNumber,
  _ as toLocale,
  ln as useBackgroundMode,
  dn as useBrowserOnline,
  gn as useContextMenu,
  fn as useCountDownToDate,
  mn as useCounterFromDate,
  ze as useCurrentFullscreenComponentId,
  De as useEffectOnce,
  vn as useEffectWithPrevDeps,
  bn as useEnterFullScreen,
  wn as useForceUpdate,
  yn as useFullscreenStatus,
  Ue as useIsMountedRef,
  N as useLastCallback,
  ke as useLongPress,
  Oe as usePrevious,
  W as useStateRef,
  En as useSyncEffect,
  Re as useTimeout,
  hn as useTimer
};
//# sourceMappingURL=main.js.map
